import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'

export default function CommitteeAssignments() {
    return (
        <div>

            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row mb-3 mx-1'>
                        <h3>Committee Assignments</h3>
                    </div>
                    <div className='row ms-3'>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>EXECUTIVE COMMITTEE</h6>
                                <p>
                                    Mark Evans (Chair) <br />
                                    John R. Bartos <br />
                                    Marvin Marcell <br />
                                    David Bailey <br />
                                    Arthur Bredehoft
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>GROUNDWATER SUPPLY COMMITTEE</h6>
                                <p>
                                    Mike Turco (Chair) <br />
                                    Sarah Kouba <br />
                                    David Bailey <br />
                                    Carl Burch<br />
                                    Cynthia Wagener<br />
                                    Mark Evans*
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>REGION H NOMINATING COMMITTEE</h6>
                                <p>
                                    Jun Chang (Chair) <br />
                                    David Bailey <br />
                                    Alisa Max <br />
                                    Mike Turco <br />
                                    Mark Evans*<br />
                                    Brad Brunett
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>SURFACE WATER SUPPLY COMMITTEE</h6>
                                <p>
                                    Kevin Ward (Chair)<br />
                                    Brad Brunett<br />
                                    Jake Hollingsworth<br />
                                    Jun Chang<br />
                                    Aubrey Spear<br />
                                    Mark Evans*
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>NON-POPULATION DEMANDS COMMITTEE</h6>
                                <p>
                                    Carl Burch (Chair) <br />
                                    Cynthia Wagener <br />
                                    Jason Garrard <br />
                                    Loyd Smith <br />
                                    Arthur Bredehoft <br />
                                    Mark Evans*
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>POPULATION DEMANDS COMMITTEE</h6>
                                <p>
                                    Marvin Marcell (Chair)<br />
                                    Mike Turco<br />
                                    Byron Ryder<br />
                                    Mark Evans*

                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>LEGISLATIVE COMMITTEE</h6>
                                <p>
                                    Marvin Marcell (Chair)<br />
                                    John Bartos<br />
                                    Carl Burch<br />
                                    Jun Chang<br />
                                    Mike Turco<br />
                                    J. Kevin Ward
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>BRAZOS ALLUVIUM</h6>
                                <p>
                                    Jake Hollingsworth (Chair)<br />
                                    Brad Brunett<br />
                                    Ken Kramer<br />
                                    Mike Turco (non-voting)<br />
                                    Mark Evans*
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='row'>
                                <h6>WATER MANAGEMENT STRATEGY COMMITTEE</h6>
                                <p>
                                    John Bartos (Chair)<br />
                                    Brad Brunett<br />
                                    Ken Kramer<br />
                                    Jun Chang<br />
                                    Mike Turco<br />
                                    Jake Hollingsworth<br />
                                    Cynthia Wagener<br />
                                    Kevin Ward<br />
                                    Aubrey Spear<br />
                                    Arthur Bredehoft<br />
                                    Mark Evans*
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className='row text-center my-2'>
                        <h5>*Non-voting</h5>
                        <h6>*The Region H chair is an ex-officio (non-voting) member of all committees.</h6>
                    </div>
                </div>
            </main>

        </div>
    )
}
